<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-12">
          <h1 class="title is-2">Getting Started</h1>
        </div>
      </div>
      <div class="columns">
        <div class="column is-3">
          <aside class="menu">
            <p class="menu-label">
              Navigation
            </p>
            <ul class="menu-list">
              <li>
                <a href="#registration">Registration</a>
              </li>
              <li>
                <a href="#adding-vehicle">Adding Vehicle</a>
              </li>
              <li>
                <a href="#tracking-gas">Tracking Gas</a>
              </li>
              <li>
                <a href="#tracking-expenses">Tracking Expenses</a>
              </li>
              <li>
                <a href="#localization">Localization</a>
              </li>
            </ul>
          </aside>
        </div>

        <div class="column is-9">
          <h2 class="title" id="registration">Registration</h2>
          <p>
            Registration is easy, just head to
            <router-link :to="{ name: 'home' }">Homepage</router-link>
            and fill out sign up form.
            After that you will be redirected to dashboard and can start configuring application
            from there.
          </p>
          <hr>

          <h2 class="title" id="adding-vehicle">Adding Vehicle</h2>
          <p>
            After signing up head to "Cars" section from navigation and click "Add New" button. You
            will be prompted to fill out details and upload car image and after that is done you can
            start tracking your expanses.
          </p>
          <hr>

          <h2 class="title" id="tracking-gas">Tracking Gas Usage</h2>
          <p>
            To start tracking Gas usage and mileage head to "Gas" section next time you refuel your
            car. You will need to fill details- date, current odometer, volume refueled,
            total price and if you refueled full tank and if this is concurrent fuel up or you have
            missed few before this one. This information is important to correctly calculate mpg
            and price per mile/kilometer.
          </p>
          <hr>

          <h2 class="title" id="tracking-expenses">Tracking Expenses</h2>
          <p>
            To start tracking vehicle expenses such as maintenance cost of changing oil or new pair
            of winter tires first you have to head to settings and under "Expense Categories" create
            categories you want to track. We want to give our users full control so we don't limit
            categories they are tracking. You have sports bike and want to have category for track
            day tickets- just add it.
          </p>

          <p>
            After you have created categories head to car expenses tab and add new entry with date,
            price and description. That is it, now your expenses will be added to calculations.
          </p>
          <hr>

          <h2 class="title" id="localization">Localization</h2>
          <p>
            There are several settings under settings tab to personalize units and timezones.
          </p>
          <hr>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GettingStarted',
};
</script>

<style scoped>

</style>
